/*
 * Copyright (c) 2019 Pegasystems Inc.
 * All rights reserved.
 */
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { resolveRestApi } from '../../router/app-router';
import { fetch } from '../../service_broker/fetch';
import { GET_DATA_OBJECT_ACTIONS } from '../../store/state/actions';
import { logAndCatchError } from '../../utils/rxjs-utils';

import type { ActionPayload, Response } from './types';

const DXAPI_ERROR = 'Error occurred during ajax call at GET data object actions : ';

const executeAsyncRequest = (payload: ActionPayload) => {
  const { dataViewID, dataViewParameters, context } = payload;
  const requestPayloadAPI = {
    data_view_ID: dataViewID
  };
  const { restApi: restUrl, reqType } = resolveRestApi(GET_DATA_OBJECT_ACTIONS, requestPayloadAPI);

  return from(
    fetch(
      restUrl,
      {
        method: reqType,
        body: {
          dataViewParameters
        }
      },
      context
    )
  ).pipe(
    map((response: Response) => {
      const responseData = response.data;
      return {
        ...responseData
      };
    }),
    logAndCatchError(DXAPI_ERROR, payload.context)
  );
};

export default executeAsyncRequest;
